import { render, staticRenderFns } from "./BillingSettings.vue?vue&type=template&id=44476340&scoped=true&"
import script from "./BillingSettings.vue?vue&type=script&lang=js&"
export * from "./BillingSettings.vue?vue&type=script&lang=js&"
import style0 from "./BillingSettings.vue?vue&type=style&index=0&id=44476340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44476340",
  null
  
)

export default component.exports